<template>
  <div class="assets-manager bg-primary6 h-full w-full flex flex-col pa-4 rounded-tl-4">
    <div v-if="showHeader" class="assets-manager__header flex items-center justify-between mb-4">
      <h2 v-if="title" class="text-xl font-semibold m-0">{{ title }}</h2>
      <slot name="header-actions" />
    </div>

    <div class="assets-manager__content flex-1 overflow-hidden">
      <AssetsTab
        ref="assetsTabRef"
        :allowed-asset-content-types="allowedAssetContentTypes"
        :core-rest-api-axios="coreRestApiAxios"
        :enable-theme-asset-protection="enableThemeAssetProtection"
        :file-deleter="fileDeleter"
        :file-list-fetcher="fileListFetcher"
        :instance-id="instanceId"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { AxiosInstance } from 'axios'

import AssetsTab from './AssetsTab.vue'
import type { File } from '@openapi'

export interface AppProps {
  // Network functions
  fileListFetcher?: (params: { filters: Record<string, any>; page_size: number }) => Promise<File[]>
  fileDeleter?: (fileId: string) => Promise<any>
  coreRestApiAxios?: AxiosInstance

  // Configuration
  allowedAssetContentTypes?: string[]
  enableThemeAssetProtection?: boolean
  instanceId?: string

  // UI Configuration
  title?: string
  showHeader?: boolean
}

withDefaults(defineProps<AppProps>(), {
  enableThemeAssetProtection: true,
  showHeader: true,
})
const assetsTabRef = ref()

defineExpose({
  fetchAssets: () => assetsTabRef.value?.fetchAssets?.(),
})
</script>
